module.exports = __webpack_public_path__ + "img/trojan-horse.9baf5e68.png";